"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var selectors_1 = require("../inc/selectors");

var pose_setter_1 = require("./pose-setter");

var style_value_types_1 = require("style-value-types");

var transformers_1 = require("popmotion/transformers");

var value_1 = require("popmotion/reactions/value");

var valueTypeTests = [style_value_types_1.number, style_value_types_1.degrees, style_value_types_1.percent, style_value_types_1.px];

var testValueType = function testValueType(v) {
  return function (type) {
    return type.test(v);
  };
};

var getInitialValue = function getInitialValue(poses, key, initialPose, styler, props) {
  var posesToSearch = Array.isArray(initialPose) ? initialPose : [initialPose];
  var pose = posesToSearch.find(function (name) {
    return poses[name] && poses[name][key] !== undefined;
  });
  return pose ? pose_setter_1.resolveProp(poses[pose][key], props) : styler.get(key);
};

var createValues = function createValues(values, types, _a, pose) {
  var initialPose = _a.initialPose,
      poses = _a.poses,
      styler = _a.styler,
      userSetValues = _a.userSetValues,
      getTransitionProps = _a.getTransitionProps;
  return function (key) {
    if (values.has(key)) return;
    var thisValue;
    var type;

    if (userSetValues && userSetValues[key] !== undefined) {
      thisValue = userSetValues[key];
      type = valueTypeTests.find(testValueType(thisValue.get()));
    } else {
      var initialValue = getInitialValue(poses, key, initialPose, styler, getTransitionProps());
      type = valueTypeTests.find(testValueType(pose[key]));
      thisValue = value_1.default(type === style_value_types_1.number ? type.parse(initialValue) : initialValue);
    }

    values.set(key, thisValue);
    thisValue.subscribe(function (v) {
      return styler.set(key, v);
    });
    if (type && type !== style_value_types_1.number) types.set(key, type);
  };
};

var scrapeValuesFromPose = function scrapeValuesFromPose(values, types, props) {
  return function (key) {
    var pose = props.poses[key];
    Object.keys(selectors_1.getPoseValues(pose)).forEach(createValues(values, types, props, pose));
  };
};

var getAncestorValue = function getAncestorValue(key, fromParent, ancestors) {
  if (fromParent === true) {
    return ancestors[0] && ancestors[0].values.get(key);
  } else {
    var foundAncestor = ancestors.find(function (_a) {
      var label = _a.label;
      return label === fromParent;
    });
    return foundAncestor && foundAncestor.values.get(key);
  }
};

var bindPassiveValues = function bindPassiveValues(values, _a) {
  var passive = _a.passive,
      ancestorValues = _a.ancestorValues,
      styler = _a.styler;
  return function (key) {
    var _a = passive[key],
        valueKey = _a[0],
        transform = _a[1],
        fromParent = _a[2];
    var valueToBind = fromParent && ancestorValues.length ? getAncestorValue(valueKey, fromParent, ancestorValues) : values.has(valueKey) ? values.get(valueKey) : false;
    if (!valueToBind) return;
    var newValue = value_1.default(valueToBind.get(), transformers_1.pipe(transform, function (v) {
      return styler.set(key, v);
    }));
    valueToBind.subscribe(newValue);
    values.set(key, newValue);
  };
};

var bindOnChange = function bindOnChange(values, onChange) {
  return function (key) {
    if (values.has(key)) values.get(key).subscribe(onChange[key]);
  };
};

var createValuesAndTypes = function createValuesAndTypes(props) {
  var passive = props.passive,
      poses = props.poses,
      onChange = props.onChange;
  var values = new Map();
  var types = new Map();
  Object.keys(poses).forEach(scrapeValuesFromPose(values, types, props));
  if (passive) Object.keys(passive).forEach(bindPassiveValues(values, props));
  if (onChange) Object.keys(onChange).forEach(bindOnChange(values, onChange));
  return {
    values: values,
    types: types
  };
};

exports.default = createValuesAndTypes;